import { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Form } from "react-bootstrap";
import {
  Container,
  Card,
  FormGroup,
  FormControl,
  ButtonLogin,
} from "./index.style";
import React from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useUser } from "../../store/UserStore";
import { getMyDetail, adminLogin } from "../../services/admin.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";

const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [data, setData] = useState<{ [key: string]: string }>({});
  const userContext = useUser();
  const history = useHistory();
  const { onError } = useError();
  React.useEffect(() => {
    const fetchData = async () => {
      if (userContext.userData) return history.replace("/");
      const token = localStorage.getItem("token");
      if (!token) return;
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      try {
        const resToken = await getMyDetail();
        userContext.setUserData(resToken.data);
        history.replace("/");
        //@ts-ignore
      } catch (error: any) {
        localStorage.removeItem("token");
      }
    };
    fetchData();
  }, [history, userContext, onError]);

  const onClickLogin = async () => {
    setIsLogin(true);
    try {
      const r = await adminLogin(data);
      const res: { [key: string]: string } = r.data;
      const idToken = res["idToken"];
      axios.defaults.headers.common["Authorization"] = "Bearer " + idToken;
      localStorage.setItem("token", idToken);
      const resToken = await getMyDetail();
      if (!resToken.data) return setIsLogin(false);
      userContext.setUserData(resToken.data);
      setIsLogin(false);
      history.replace("/");
    } catch (error: any) {
      setIsLogin(false);
      return onError(GetErrorMessage(error));
    }
  };
  const handleChangeData = (key: string, value: string) => {
    const nData = data;
    nData[key] = value;
    setData(nData);
  };

  return (
    <Container>
      <Card>
        <h1>Pettinee Manager</h1>
        <h2>เข้าสู่ระบบ</h2>
        <FormGroup>
          <Form.Label>Username</Form.Label>
          <FormControl
            placeholder="ชื่อผู้ใช้งาน"
            onChange={(e: React.ChangeEvent<{ value: string }>) =>
              handleChangeData("username", e.target.value)
            }
          />
        </FormGroup>
        <FormGroup>
          <Form.Label>Password</Form.Label>
          <FormControl
            type="password"
            placeholder="รหัสผ่าน"
            onChange={(e: React.ChangeEvent<{ value: string }>) =>
              handleChangeData("password", e.target.value)
            }
          />
        </FormGroup>
        <ButtonLogin variant="brand" onClick={onClickLogin} isLoading={isLogin}>
          <div>เข้าสู่ระบบ</div>
          <div>
            <BsArrowRight size="32px" />
          </div>
        </ButtonLogin>
      </Card>
    </Container>
  );
};

export default LoginPage;
